/**
 * Picks a number in the configured range and drifts it slowly, so the strip does not
 * sit on one static figure. Generated client-side — not real analytics.
 */
class LiveViewers extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-viewers-count]');
    this.min = Math.max(1, Number(this.dataset.min) || 1);
    this.max = Math.max(this.min, Number(this.dataset.max) || this.min);

    this.current = this.#random(this.min, this.max);
    this.#render();

    const seconds = Number(this.dataset.interval) || 0;
    if (seconds > 0) {
      this.timer = setInterval(() => this.#drift(), seconds * 1000);
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  #random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /** Small +/- steps read more naturally than re-rolling the whole range. */
  #drift() {
    const step = this.#random(-2, 2);
    this.current = Math.min(this.max, Math.max(this.min, this.current + step));
    this.#render();
  }

  #render() {
    if (this.output) this.output.textContent = String(this.current);
  }
}

if (!customElements.get('live-viewers')) {
  customElements.define('live-viewers', LiveViewers);
}
